module.exports = __webpack_public_path__ + "img/history.a3ba48a8.svg";